import { render } from "./Requisitions.vue?vue&type=template&id=5c2199be"
import script from "./Requisitions.vue?vue&type=script&lang=js"
export * from "./Requisitions.vue?vue&type=script&lang=js"
script.render = render

export default script